import type { ComponentProps } from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"
import { cn } from "@holigral/shared/ui/lib/utils"

function Input({ className, type, ...props }: ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        // The surface alternates: a field on paper takes the card colour, and
        // a field on anything raised takes the paper colour. Same border, same
        // focus ring either way — only the fill swaps, so a field is always a
        // step away from whatever it sits on.
        //
        // `--field-surface` is what makes that automatic: raised surfaces flip
        // it and fields read it, so neither a call site nor this component has
        // to know where it is. The list of raised surfaces is in globals.css.
        "h-9 w-full min-w-0 rounded-md border border-input bg-field-surface px-[11px] py-[9px] font-sans text-base transition-colors outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ring focus-visible:outline-solid disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive md:text-sm",
        className,
      )}
      {...props}
    />
  )
}

export { Input }
